import { FirebaseClientConfigSchema, parseEnv } from '@kilat/shared';
import { z } from 'zod';

const RuntimeEnvSchema = z.object({
  MODE: z.enum(['development', 'production', 'test']),
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
  VITE_FIREBASE_STORAGE_BUCKET: z.string().min(1),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().min(1),
  VITE_FIREBASE_APP_ID: z.string().min(1),
  VITE_FIREBASE_MEASUREMENT_ID: z.string().optional(),
  VITE_USE_EMULATORS: z
    .union([z.literal('true'), z.literal('false')])
    .default('false')
    .transform((v) => v === 'true'),
  VITE_FCM_VAPID_KEY: z
    .string()
    .optional()
    .describe('FCM Web Push VAPID key — agent push (sign-ups, commissions, payouts)'),
});

const raw = parseEnv(RuntimeEnvSchema, import.meta.env, 'agent-pwa');

export const env = {
  mode: raw.MODE,
  useEmulators: raw.VITE_USE_EMULATORS,
  fcmVapidKey: raw.VITE_FCM_VAPID_KEY,
  firebase: parseEnv(
    FirebaseClientConfigSchema,
    {
      apiKey: raw.VITE_FIREBASE_API_KEY,
      authDomain: raw.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: raw.VITE_FIREBASE_PROJECT_ID,
      storageBucket: raw.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: raw.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: raw.VITE_FIREBASE_APP_ID,
      measurementId: raw.VITE_FIREBASE_MEASUREMENT_ID,
    },
    'agent-pwa.firebase',
  ),
} as const;
export type Env = typeof env;
